import { requestsUseCase } from '../../../core/usecases'
import { ref, watch } from '@vue/composition-api'
import useRouter from '../useRouter'

const usePartnerCampaigns = (userId) => {

    const partnerCampaigns = ref(null)

    const {route} = useRouter();
  
    const setCampaigns = async (campaigns, partnerFromUpdates) => {

        let conditionParams = {
            must: [{
                term: {
                    [campaigns[0] + '.uid']: userId
                }
            }]
        }

        if(partnerFromUpdates) {
            conditionParams = {
                should: [
                    {
                        bool: {
                            must: [
                                {
                                    term: {
                                        [campaigns[0] + '.uid']: userId,
                                    },
                                    term: {
                                        status: 'accepted'
                                    }
                                }
                            ]
                        },
                    },
                    {
                        bool: {
                            must: [
                                {
                                    term: {
                                        [campaigns[1] + '.uid']: userId,
                                    },
                                    term: {
                                        status: 'accepted'
                                    }
                                }
                            ]
                        },
                    }
                ]
            }
        }

        // getting requests with other campaigns
        const requestsData = await requestsUseCase.getRequestsList(0, 10000, conditionParams)
        const requestsCampaigns = [];
        const map = new Map();

        if(!requestsData){
            return
        }

        // filtering repeating campaigns from requests
        for (const item of requestsData.requests) {
            const receiverOrSender = !partnerFromUpdates ? item[campaigns[1]] : (item.receiver.uid === userId  ? item.sender : item.receiver)
            if(!map.has(receiverOrSender.campaign)){
                map.set(receiverOrSender.campaign, true)
                requestsCampaigns.push({
                    ...receiverOrSender,
                    id: receiverOrSender.campaign
                });
            }
        }

        partnerCampaigns.value = [...requestsCampaigns];
    }

    watch(route, (newRoute, oldRoute) => {
        if(oldRoute && newRoute.query.type === oldRoute.query.type && newRoute.name === oldRoute.name){
            return
        }
        if(newRoute.query.type === 'unscheduled') {
            return
        }
        const campaigns = newRoute.query.type === 'sent' ? ['sender', 'receiver'] : ['receiver', 'sender']
        setCampaigns(campaigns, newRoute.name === 'updates');
    }, {immediate: true})

    return {
        partnerCampaigns
    }
} 

export default usePartnerCampaigns
